import { render, staticRenderFns } from "./AplicacaoRecursoForm.vue?vue&type=template&id=43192e12&"
import script from "./AplicacaoRecursoForm.vue?vue&type=script&lang=js&"
export * from "./AplicacaoRecursoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports